var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/**
 * This is the editor for the simple-markdown-tester widget. This is what shows
 * up on the left side of the screen in the demo. Only the question writer
 * sees this.
 */
var React = require("react");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var TextArea = React.createClass({
    displayName: "TextArea",

    render: function render() {
        return React.createElement("textarea", {
            ref: "input",
            value: this.props.value || "",
            onChange: this.changeValue
        });
    },

    focus: function focus() {
        this.refs.input.focus();
        return true;
    },

    changeValue: function changeValue(e) {
        // Translating from the js event e to the value
        // of the textbox to send to onChange
        this.props.onChange(e.target.value);
    }
});

var SimpleMarkdownTesterEditor = React.createClass({
    displayName: "SimpleMarkdownTesterEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            value: ""
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "label",
                null,
                React.createElement(
                    "div",
                    null,
                    "Simple markdown contents:"
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(TextArea, {
                        value: this.props.value,
                        onChange: this.change("value"),
                        ref: "input"
                    })
                )
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    focus: function focus() {
        this.refs.input.focus();
        return true;
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = SimpleMarkdownTesterEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/simple-markdown-tester-editor.jsx
 ** module id = 163
 ** module chunks = 0 1
 **/